import React from 'react';
import PropTypes from 'prop-types';
import { format, isValid } from 'date-fns';
import * as S from './styled';

const DATE_FORMAT_MMM_DD_YYYY = 'MMM dd, yyyy';

// TODO: maybe move it to shared components for the reuse in all tables

export const SimpleCell = ({ value, withTitle, withEllipsis, onClick, Icon, disabled, firstColCell }) => (
  <S.Cell
    $withEllipsis={withEllipsis}
    $withIcon={!!Icon}
    $firstColCell={firstColCell}
    title={withTitle && value}
    onClick={onClick}
    disabled={disabled}>
    <span>{value}</span>
    {Icon}
  </S.Cell>
);

SimpleCell.propTypes = {
  value: PropTypes.string,
  withTitle: PropTypes.bool,
  withEllipsis: PropTypes.bool,
  disabled: PropTypes.bool,
  firstColCell: PropTypes.bool,
  onClick: PropTypes.func,
  Icon: PropTypes.element
};

export const DateCell = ({ value, renderedCellValue }) => {
  const val = value || renderedCellValue;
  if (!val) return null;
  const date = new Date(val);

  return isValid(date) ? <S.Cell>{format(date, DATE_FORMAT_MMM_DD_YYYY)}</S.Cell> : <S.Cell>{val}</S.Cell>;
};

DateCell.propTypes = { value: PropTypes.string, renderedCellValue: PropTypes.string };
